import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Config, ConfigAnalytics } from '../models/config.model';
import { PaginationRequest } from '../models/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  config: Config = {
    childEntities: [],
    paginations: {
      settings: {
        apps: {},
        settingsTab: {},
        settings: {}
      }
    }
  };

  public currentConfigSubject: BehaviorSubject<Config> = new BehaviorSubject(this.config);
  public currentConfig!: Observable<Config>;

  constructor() { }

  public get currentConfigValue(): Config {
    return this.currentConfigSubject.value;
  }
  public setCurrentConfig(_config: Config) {
    this.currentConfigSubject.next(_config);
  }

  public clear() {
    let newConfig: Config = {
      childEntities: [],
      paginations: {
        settings: {
          apps: {},
          settingsTab: {},
          settings: {}
        }
      }
    };
    this.currentConfigSubject.next(newConfig);
  }

  public setConfigParamsValue(_key: string, _value: any) {
    switch (_key) {
      case 'horizonsTeams':
      case 'teams':
        _value.sort((a: any, b: any) => a.name.localeCompare(b.name));
        break;
      default:
        break;
    }
    this.currentConfigValue[_key] = _value;
    this.currentConfigSubject.next(this.currentConfigValue);
  }

  public setConfigPathsValue(_url: any) {
    !this.currentConfigValue.paths ? this.currentConfigValue.paths = {} : null;
    const urlParts = _url.split('/').filter((s: string) => s)
    this.currentConfigValue.paths[urlParts[0]] = { path: urlParts[0], subPath: urlParts[1] };
    this.currentConfigSubject.next(this.currentConfigValue);
  }
  public setConfigPaginationOpenValue(_page: string, _entityId: number) {
    this.currentConfigValue.paginations![_page].entityId = _entityId;
    this.currentConfigSubject.next(this.currentConfigValue);
  }
  public setConfigPaginationParamValue(_page: string, _param: any, _value: any) {
    !this.currentConfigValue.paginations![_page] ? this.currentConfigValue.paginations![_page] = {} : null;
    this.currentConfigValue.paginations![_page][_param] = _value;
    this.currentConfigSubject.next(this.currentConfigValue);
  }
  public setConfigAppsValue(_page: string, _entity: any, _value: any) {
    this.currentConfigValue.paginations![_page].apps![_entity] = _value;
    this.currentConfigSubject.next(this.currentConfigValue);
  }
  public setConfigSettingsValue(_page: string, _entity: any, _settings: string, _value: any) {
    !this.currentConfigValue.paginations![_page].settings![_entity] ? this.currentConfigValue.paginations![_page].settings![_entity] = {} : null;
    this.currentConfigValue.paginations![_page].settings![_entity][_settings] = _value;
    this.currentConfigSubject.next(this.currentConfigValue);
  }

  public resetAnalyticsPackagesCollectionAcumulateValue() {
    this.currentConfigValue.analytics ??= {} as ConfigAnalytics;
    this.currentConfigValue.analytics!.packages = [];
    this.currentConfigSubject.next(this.currentConfigValue);
  }

  public setAnalyticsPackagesCollectionAcumulateValue(_value: any) {
    this.currentConfigValue.analytics!.packages = [...this.currentConfigValue.analytics!.packages, ..._value];
    this.currentConfigSubject.next(this.currentConfigValue);
  }
}
